import {css} from "lit";

export const navigationItemStyles = css`
  :host {
    /*display: flex;
    flex-direction: row;
    height: var(--ha-step-m, 1.5rem);
    gap: var(--ha-gap-m, .5rem);*/
  }

  .ha-app__navigation-item__prefix {
    /*display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1 / 1;
    border: 1px solid forestgreen;
    width: var(--ha-step-m, 1.5rem);*/
  }
  
  .ha-app__navigation-item__label {
    /*display: flex;
    flex-grow: 1;*/
  }

  .collapsed {
    /*display: none;*/
  }
`;